const styles = {
  iframeContainer: {
    width: "100%",
    height: "100%",
    border: 0,
    padding: 0,
    margin: 0,
  },
  legacy: {
    maxWidth: "800px",
  },
};

export default styles;
